import { render, staticRenderFns } from "./wtr-selection-dropdown.vue?vue&type=template&id=ff6f9fdc&scoped=true&"
import script from "./wtr-selection-dropdown.vue?vue&type=script&lang=js&"
export * from "./wtr-selection-dropdown.vue?vue&type=script&lang=js&"
import style0 from "./wtr-selection-dropdown.vue?vue&type=style&index=0&id=ff6f9fdc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff6f9fdc",
  null
  
)

export default component.exports